export const pushRebrandedUrl = () => {
  const currHostname = window.location.hostname
  if (currHostname.includes('booking.leaseplan.com')) {
    const { pathname, search, hash } = window.location
    const newUrl = `https://booking.ayvens.com${pathname}${search}${hash}`
    window.location.href = newUrl
  }
}
